export const CONFIG_CHANGE = 'CONFIG_CHANGE';
export const THEME_CHANGE = 'THEME_CHANGE';
export const SCENARIO_ADDED = 'SCENARIO_ADDED';
export const SCENARIO_REMOVED = 'SCENARIO_REMOVED';
export const LIFECYCLE_ORDER_CHANGE = 'LIFECYCLE_ORDER_CHANGE';
export const CREATED = 'CREATED';
export const DELETED = 'DELETED';
export const DUPLICATED = 'DUPLICATED';
export const ALFRESCO_ASSETS_UPDATE = 'ALFRESCO_ASSETS_UPDATE';